import { PersonModel } from './person.model';
import { FunctionModel } from './function.model';

export class ParticipantModel {
  public id: number;
  public person: PersonModel;
  public function: FunctionModel;

  /* Old Atributes */
  public orderInFunction: number;

  constructor() {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: ParticipantModel[] = [];
    jsons.forEach(json => {
      refs.push(new ParticipantModel().fromJSON(json));
    });
    return refs;
  }
}
